import { AzureDataBricksLinkedService } from './../../model/linkedservice/azure-data-bricks.linkedservice';
import { Metamodel } from 'app/model/base/model';
import { ConnectionAuthKind } from 'shell-models-lib';
import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';
import { GlobalVariables } from 'app/services/globals';

export const azureDataBricksMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(AzureDataBricksLinkedService).name,
    displayName: stringResources.AzureDataBricks_DisplayText,
    icon: {
        className: 'svg-i_databricks_16x16'
    },
    category: ['Azure'],
    isFirstClass: true,
    isCompute: true,
    supportFirstClassParameterExperience: true,
    supportedInTrident: true,
    supportAutoFillCopilotInput: true,
    isKnownInPipelineContext: true,
    supportedAuthKindsInTrident: [ConnectionAuthKind.Key, ConnectionAuthKind.ServicePrincipal, ConnectionAuthKind.OAuth2, ConnectionAuthKind.WorkspaceIdentity],
    pqoDataSourceOption: {
        kind: DataSourceOptionKind.Extension,
        resourceKind: 'AzureDatabricksWorkspace' as ResourceKind
    },
    supportOPDG: GlobalVariables.enableOPDG,
    controls: [
        {
            type: 'azure-databricks-linkedservice-setting'
        }
    ],
    copySinkTypes: [],
    copySourceTypes: []
};
